"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushNotification = void 0;

var _actions = require("./actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var injectNamespaceToNotification = function injectNamespaceToNotification(notification, namespace) {
  return _objectSpread(_objectSpread({}, notification), {}, {
    namespace: namespace
  });
};

var pushNotification = function pushNotification(notifications, namespace, dispatch) {
  if (namespace) {
    // clear notifications by namespace
    // the namespace can be found inside the notification.namespace, but we have to use it as an additional param,
    // because when the validation is correct and there is no error, we cannot loop through the notifications array
    // therefore we cannot get the namespace we need to clear
    dispatch((0, _actions.notificationsClearByNamespace)(namespace));
  }

  notifications.forEach(function (notification) {
    // when the notification is created by validators, they doesn't know about the namespace for the parameter, they only check value
    // therefore we need to inject this namespace, when we push the final notification to state
    var notificationWithNamespace = injectNamespaceToNotification(notification, namespace);
    dispatch((0, _actions.notificationPush)(notificationWithNamespace));
  });
};

exports.pushNotification = pushNotification;
//# sourceMappingURL=push-notification.js.map